import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Badge, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

import Pagination from 'components/Pagination'
import ModalSearch from 'components/Modal/ModalSearch'

import { useRecipientContext } from './RecipientContext'

function TableListHeader() {
  const [showSearch, setShowSearch] = useState(false)
  const { loading, search, currentPage, totalPage, dispatch } =
    useRecipientContext()

  const handleSearch = (value: string) => {
    if (value !== search) {
      dispatch({ type: 'SET_SEARCH', payload: value })
    }
  }

  const handlePageChange = (newPage: number) => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: newPage })
  }

  return (
    <React.Fragment>
      <div className='table-list-header sticky'>
        <div className='left'>
          <Pagination
            disabled={loading}
            current={currentPage}
            total={totalPage}
            onPageChange={handlePageChange}
          />
        </div>
        <div className='right'>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowSearch(true)}
          >
            <Badge dot={!!search}>
              <SearchOutlined />
            </Badge>
          </Button>
        </div>
      </div>
      <AnimatePresence>
        {showSearch && (
          <ModalSearch
            title='Search Recipients'
            placeholder='Search recipients'
            value={search}
            onSearch={handleSearch}
            onCancel={() => setShowSearch(false)}
          />
        )}
      </AnimatePresence>
    </React.Fragment>
  )
}

export default TableListHeader
